import { RouteView, PageView } from '@/components/layouts'
import contract from '@/views/contract/contract/contract'

export default {
  path: '/contract',
  name: '/contract',
  component: RouteView,
  meta: { title: '我的合同', keepAlive: false, icon: 'fa fa-credit-card-alt' },
  children: [
    {
      path: '/contract/contract',
      name: '/contract/contract',
      component: PageView,
      meta: { title: '合同管理', keepAlive: false, icon: 'el-icon-star-on' },
      children: [
        {
          path: '/contract/contract/contract',
          name: '/contract/contract/contract',
          component: contract,
          meta: { title: '合同管理', keepAlive: false, action: [] }
        },
      ]
    }
  ]
}
